import { jsx, jsxs } from "react/jsx-runtime";
/* empty css          */
function isObject(value) {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}
function isListOfObjects(value) {
  return Array.isArray(value) && value.length > 0 && typeof value[0] === "object" && value[0] !== null;
}
function findListGroup(data, path = []) {
  if (!isObject(data)) {
    return null;
  }
  const entries = Object.entries(data);
  const lists = entries.filter(([, value]) => isListOfObjects(value));
  if (lists.length > 0) {
    return lists.map(([key, value]) => ({
      path: [...path, key].join("."),
      rows: value
    }));
  }
  for (const [key, value] of entries) {
    const nested = findListGroup(value, [...path, key]);
    if (nested) {
      return nested;
    }
  }
  return null;
}
function formatCell(value) {
  if (value === null || value === void 0) {
    return "—";
  }
  if (Array.isArray(value)) {
    return `Array [${value.length}]`;
  }
  if (typeof value === "object") {
    return `Object {${Object.keys(value).length}}`;
  }
  return String(value);
}
const ResponseTable = ({
  path,
  rows
}) => {
  const cols = Array.from(new Set(rows.flatMap((row) => Object.keys(row ?? {}))));
  return /* @__PURE__ */ jsxs("table", { className: "graphiql-response-table", children: [
    /* @__PURE__ */ jsx("caption", { className: "graphiql-response-table-caption", children: path }),
    /* @__PURE__ */ jsx("thead", { children: /* @__PURE__ */ jsx("tr", { children: cols.map((col) => /* @__PURE__ */ jsx("th", { scope: "col", children: col }, col)) }) }),
    /* @__PURE__ */ jsx("tbody", { children: rows.map((row_0, i) => (
      // eslint-disable-next-line react/no-array-index-key
      /* @__PURE__ */ jsx("tr", { children: cols.map((col_0) => /* @__PURE__ */ jsx("td", { children: formatCell(row_0[col_0]) }, col_0)) }, i)
    )) })
  ] });
};
const ResponseTableView = ({
  data
}) => {
  const root = isObject(data) && "data" in data ? data.data : data;
  const matches = findListGroup(root);
  if (!matches) {
    return /* @__PURE__ */ jsx("div", { className: "graphiql-response-table-empty", role: "status", children: "Table view requires a list response." });
  }
  return /* @__PURE__ */ jsx("div", { className: "graphiql-response-table-wrapper", children: matches.map((match) => /* @__PURE__ */ jsx(ResponseTable, { path: match.path, rows: match.rows }, match.path)) });
};
export {
  ResponseTableView
};
//# sourceMappingURL=index.js.map
